import React from 'react';
import ForgotPasswordForm from '../../components/forgotPassword/ForgotPasswordForm';

const ForgotPassword = () => {
  return (
    <div className="forgot-password-container">
      <ForgotPasswordForm/>
    </div>
  )
}

export default ForgotPassword